<template lang="pug">
div
  .statement-mobile
    .statement-single
      template(v-if="getReport.length > 0")
        .statement-single-content(v-for="data in getReport")
          template(v-if="category===0")
            .statement-detail
              .statement-detail-left {{data.request_type}}
              .statement-detail-right.text-warning {{data.amount}}
            .statement-detail
              .statement-detail-left {{$t('ui.bonus')}}
              .statement-detail-right {{ data.bonus_amount }}
            .statement-balance
              .statement-balance-left 
              .statement-balance-right {{ $moment(data.created_date).format("YYYY-MM-DD HH:mm:ss") }}
          template(v-else-if="category === 1")
            .statement-detail
              .statement-detail-left {{data.bonus_name}}
              .statement-detail-right.text-warning {{data.bonus_desc}}
            .statement-detail
              .statement-detail-left {{$t('ui.bonus')}}
              .statement-detail-right {{data.bonus_value}}
            .statement-balance
              .statement-balance-left 
              .statement-balance-right {{ $moment(data.created_date).format("YYYY-MM-DD HH:mm:ss") }}
          template(v-else-if="category === 2")
            .statement-detail
              .statement-detail-left {{$t('ui.remarks')}}
              .statement-detail-right.text-warning {{data.remark}}
            .statement-detail
              .statement-detail-left {{$t('ui.amount')}}
              .statement-detail-right {{data.amount}}
            .statement-balance
              .statement-balance-left 
              .statement-balance-right {{ $moment(data.created_date).format("YYYY-MM-DD HH:mm:ss") }}
          template(v-else-if="category === 3")
            .statement-detail
              .statement-detail-left ID
              .statement-detail-right {{data.account_id}}
            .statement-balance
              .statement-balance-left 
              .statement-balance-right {{ $moment(data.verified_date).format("YYYY-MM-DD HH:mm:ss") }}
      template(v-else)
        .text-center.py-2 {{ $t('ui.no_record') }}
  .statement-desktop
    .table-responsive
      table.table-history
        tr
          th No.
          template(v-if="category === 0")
            th {{$t('ui.type')}}
            th {{$t('ui.amount')}}
            th {{$t('ui.bonus')}}
            th {{$t('ui.date')}}
          template(v-else-if="category === 1")
            th {{ $t('ui.name') }}
            th {{ $t('ui.description') }}
            th {{$t('ui.type')}}
            th {{$t('ui.bonus')}}
            th {{$t('ui.date')}}
          template(v-else-if="category === 2")
            th {{ $t('ui.before_balance') }}
            th {{ $t('ui.amount') }}
            th {{$t('ui.after_balance')}}
            th {{$t('ui.remarks')}}
            th {{$t('ui.date')}}
          template(v-else)
            th ID
            th {{$t('ui.date')}}
        template(v-if="getReport.length > 0")
          tr(v-for="(data, index) in getReport")
            td {{index+1}}
            template(v-if="category === 0")
              td {{data.request_type}}
              td {{data.amount}}
              td {{data.bonus_amount}}
              td {{ $moment(data.created_date).format("YYYY-MM-DD HH:mm:ss") }}
            template(v-else-if="category === 1")
              td {{data.bonus_name}}
              td {{data.bonus_desc}}
              td {{data.bonus_type}}
              td {{data.bonus_value}}
              td {{ $moment(data.created_date).format("YYYY-MM-DD HH:mm:ss") }}
            template(v-else-if="category === 2")
              td {{data.balance_before}}
              td {{data.amount}}
              td {{data.balance_after}}
              td {{data.remark}}
              td {{ $moment(data.created_date).format("YYYY-MM-DD HH:mm:ss") }}
            template(v-else)
              td.no-uppercase {{data.account_id}}
              td {{ $moment(data.verified_date).format("YYYY-MM-DD HH:mm:ss") }}
        template(v-else)
          .text-center.py-2 {{ $t('ui.no_record') }}
</template>
<script>
export default {
  props:{   
    category: {
      type: Number,
    },
  },
  computed:{
    getReport(){
      if(this.category === 0){
        return this.$store.getters.transferDetails;
      }else if(this.category === 1){
        return this.$store.getters.promoDetails;
      }else if(this.category === 2){
        return this.$store.getters.adjustmentDetails;
      }else if(this.category === 3){
        return this.$store.getters.refereeCount;
      }else{
        return ""
      }
    }
  },
  mounted(){
    window.scroll(0, 0)
  },

}
</script>
<style lang="scss" scoped>
.custom{
  white-space: nowrap;
}
</style>